import React, {Component} from 'react';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import toasts from '../../utils/toasts';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import models from '../../model/models';
import './BloodCommUuidCard.scss';

export default class BloodCommUuidCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uuid: '',
			uuidError: null,
			loading: true
		};
	}

	componentDidMount = async () => {
		await this.fetchExistingUuid();
		this.subscribeGroupId = models.user_group.onChange(this.getData);
	}
	componentWillUnmount = () => {
		models.user_group.unsubscribe(this.subscribeGroupId);
	}
	getData = () => {
		this.setState({userGroup: models.user_group.obj()})
	};

	fetchExistingUuid = async () => {
		try {
			const userGroupId = localStorage.user_group_id;
			if (!userGroupId) {
				this.setState({
					loading: false,
					uuidError: 'User group ID not found'
				});
				return;
			}

			await userGroupSettingsManager.refresh(userGroupId);
			const existingUuid = userGroupSettingsManager.getSetting('bloodcomm_uuid');

			this.setState({
				uuid: existingUuid || '',
				loading: false
			});
		} catch (error) {
			console.error('Error fetching existing UUID:', error);
			this.setState({
				loading: false,
				uuidError: 'Error loading existing UUID'
			});
		}
	};

	_handleUuidChange = (value) => {
		this.setState({
			uuid: value,
			uuidError: null
		});
	};

	saveUuid = async () => {
		const {uuid} = this.state;

		if (!uuid) {
			this.setState({uuidError: 'Please enter BloodCOMM UUID'});
			return;
		}

		if (uuid.length < 10) {
			this.setState({uuidError: 'UUID must be at least 10 characters long'});
			return;
		}

		try {
			const user_group_id = localStorage.user_group_id;
			if (!user_group_id) {
				this.setState({uuidError: 'User group ID not found'});
				return;
			}

			await userGroupSettingsManager.upsert({name: 'bloodcomm_uuid', string_value: uuid, user_group_id});
			await userGroupSettingsManager.refresh(user_group_id);

			toasts.show('BloodCOMM UUID saved successfully');
			this.setState({
				uuidError: null,
			});
		} catch (error) {
			console.error('Error saving UUID:', error);
			this.setState({uuidError: 'Error saving UUID: ' + (error.message || 'Unknown error')});
		}
	};

	render() {
		const {uuid, uuidError, loading} = this.state;
		const userGroup = this.state.userGroup || {};
		const agencyName = userGroup ? userGroup.name : '';
		const emailSubject = agencyName ? `Enable LogRx Integration - ${agencyName}` : 'Enable LogRx Integration';
		const emailBody = agencyName
			? `Hello,\n\nI would like to request that the LogRx integration be enabled for my organization: ${agencyName}.\n\nThank you.`
			: 'Hello,\n\nI would like to request that the LogRx integration be enabled for my organization.\n\nThank you.';
		const mailtoLink = `mailto:support@deltadevteam.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

		if (loading) {
			return (
				<Card className="inner-card g-bloodcomm-uuid-card">
					<Label bold black>BloodCOMM Settings</Label>
					<div className="uuid-form">
						<div className="loading-message">
							<Label>Loading existing UUID...</Label>
						</div>
					</div>
				</Card>
			);
		}

		return (
			<Card className="inner-card g-bloodcomm-uuid-card">
				<div className={'flex-row'}>
				<BloodCommLogo/>
				<Label bold black large>BloodCOMM Settings</Label>
				</div>
				<br/>

				<Label>1. Login to <a href="https://blood.dev/settings/organization" target="_blank" rel="noopener noreferrer"
															style={{
																color: 'inherit',
																textDecoration: 'underline',
																cursor: 'pointer'
															}}>https://blood.dev/settings/organization</a> to get your Organization UUID</Label>
				<br/>
				<Label>2. <a href={mailtoLink} style={{color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>Email
					support to enable the LogRx integration</a></Label>
				<div className="uuid-form">
					<div className="form-group">
						<Label black>BloodCOMM Organization UUID</Label>
						<Input
							type="text"
							value={uuid}
							onChange={this._handleUuidChange}
							placeholder="Enter BloodCOMM UUID"
						/>
					</div>
					{uuidError && (
						<div className="error-message">
							<Label red>{uuidError}</Label>
						</div>
					)}
					<div className="uuid-actions">
						<PrimaryButton
							center
							onClick={this.saveUuid}
						>
							Save Organization UUID
						</PrimaryButton>
					</div>
				</div>
			</Card>
		);
	}
}

const BloodCommLogo = () => {
	return <svg className="g-blood-comm-logo" focusable="false"
							aria-hidden="true" viewBox="0 0 960 960" version="1.1"
							fill="currentColor" xmlns="http://www.w3.org/2000/svg">

		<defs>
			<clipPath id="clipPath4572">
				<path d="m0 720h720v-720h-720z">

				</path>
			</clipPath>
		</defs>

		<g transform="matrix(1.3333 0 0 -1.3333 0 960)">
			<g transform="matrix(1.226 0 0 1.226 -81.354 -71.129)" clipPath="url(#clipPath4572)">

			<path d="m360 627.07-13.251-16.889c-6.883-8.757-144.55-185.49-166.04-321.04 42.171 39.082 117.14 113.62 179.91 202.92 0 0 59.219-89.558 178.51-201.93-21.991 135.41-159.02 311.32-165.88 320.06zm-8e-3 -165.71s-54.067-86.679-182.09-204.44c-0.089-12.563 1.1387-24.562 3.9357-35.793 3.663-14.71 8.7004-28.614 15.04-41.654 54.532 47.353 117.23 109.02 163.8 175.98 0 0 70.688-92.24 162-176.89 6.549 13.306 11.732 27.524 15.471 42.586 2.712 10.891 3.9471 22.506 3.9381 34.656-48.843 44.466-118.12 114.75-182.1 205.55zm0-135.31c-50.033-67.397-106.56-124.33-152.44-165.76 4.976-7.868 10.488-15.359 16.548-22.434 7.848-9.15 16.577-17.376 26.006-24.629l5.7961 15.111c0.839 2.189 0.49733 4.6565-0.90567 6.5345l-19.045 25.486 15.976 21.612 29.988-9.9039c2.624-0.867 5.4995-0.48865 7.8105 1.0264l12.286 8.0567c1.968 1.291 3.1368 3.5018 3.0958 5.8558l-0.55917 32.24 25.997 7.5166 17.836-26.476c1.381-2.051 3.6921-3.2798 6.1641-3.2798h14.675c2.263 0 4.3861 1.0984 5.6921 2.9464l18.276 25.869 26.624-8.1427-1.6333-29.96c-0.154-2.816 1.0809-5.5293 3.3049-7.2633l12.13-9.457c1.749-1.364 4.0635-1.7618 6.1665-1.0598l30.462 10.154 15.66-21.612-20.359-25.73c-1.373-1.735-1.7971-4.0375-1.1351-6.1485l4.4411-14.174c9.829 7.445 18.907 15.942 27.04 25.429 5.823 6.787 11.135 13.965 15.956 21.49-85.663 79.116-151.86 166.71-151.86 166.71zm0-171.65c-36.636 0-66.536-28.727-68.468-64.881 21.374-8.661 44.586-13.273 68.476-13.273 23.881 0 47.09 4.6089 68.461 13.265-1.928 36.158-31.83 64.889-68.469 64.889z">

			</path>
			</g>
		</g>
	</svg>

}



// WEBPACK FOOTER //
// ./src/cards/bloodCommUuidCard/BloodCommUuidCard.jsx